export enum SupportedNewsLinks {
  LaunchBay = '[launchbay]',
  EditBots = '[editbots]',
  AllDayMarket = '[alldaymarket]',
  AfterSchoolMarket = '[afterschoolmarket]',
  SeasonalMarket = '[seasonalmarket]',
  ClassRoomGarden = '[classroomgarden]',
  GameOutpostRun = '[gameoutpostrun]',
  GameZoneRush = '[gamezonerush]',
  GameTerraforming = '[gameterraforming]',
  GameSelectionScreen = '[gameselectionscreen]',
  SolveTab = '[solvetab]',
  Arcade = '[arcade]',
  Mathalon = '[mathalon]',
  RequestAGameshow = '[requestagameshow]',
  AskForMission = '[askformission]'
}
